<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Broadcasts",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Broadcasts",
            items: [
               {
                  text: "Broadcasts",
                  active: true,
               },                   
            ],

            notifications: [],
            drivers: [],

            notification: {
               id: "",
               title_en: "",
               title_so: "",
               description_en: "",
               description_so: "",
               type: "",
               driver_id: '',
            },

            driver_id: '',           
            driver_type: '',
            driver_keyword: '',
            driver_visible: false,

            
            modal_title: "Add Notification",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,

            type: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            
            delete: false,
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchNotifications();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('sigofuel_fuelstation')) {
               var sigofuel_fuelstation =  JSON.parse(localStorage.getItem('sigofuel_fuelstation'));
               if(sigofuel_fuelstation.token) {
                  this.token = sigofuel_fuelstation.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchNotifications(page_url = null) {

            this.getToken();
            let url = "fuelstation/fuel_station/notification/send?keyword=" + this.keyword + "&limit=" + this.listing_length + "&type=" + this.type;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.notifications = responseData.notifications.data;
                  
                  this.pagination = responseData.notifications.links;
                  this.from = responseData.notifications.from;
                  this.to = responseData.notifications.to;
                  this.total = responseData.notifications.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         closedriverSearch() {
            this.driver_visible = false;        
            this.driver_keyword = '';
         },

        
         setdriver() {
            this.driver_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.driver_visible = false;
         },

         
         fetchdrivers() {  

            let url = "fuelstation/fuel_station/getFuelStationDrivers?keyword=" + this.driver_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.drivers = responseData.drivers;
                  this.driver_visible = true;
               })
               .catch((err) => console.log(err));
               
         },

         
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

        
         addNotification() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

          //  if(!this.edit) {
               url = "fuelstation/fuel_station/notification/add";
               this.active_page_url = null;

            /* } else {
               url = "fuelstation/fuel_station/notification/edit";
               formData.append("notification_id", this.notification.id); 
            } */         

            formData.append("title_en", this.notification.title_en);
                         formData.append("title_so", this.notification.title_so);

            formData.append("description_en", this.notification.description_en); 
                        formData.append("description_so", this.notification.description_so); 
                  formData.append("user_id", this.driver_id); 
              
               
               
                       this.showModal("notification-modal");

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('notification-modal');
                  this.fetchNotifications(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {
            this.edit = false;
            this.notification.id = "";
            this.notification.title_en = "";
            this.notification.title_so = "";
            this.notification.description_en = "";
            this.notification.description_so = "";
          this.notification.type = '';
            this.driver_id = '';
            this.driver_keyword = '';
            this.modal_title = "Add Notification";
            this.button_title = "Save";
            this.errors = {};

            this.driver_id = '';
            this.driver_type = '';
            this.driver_keyword = '';

             },

         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.notification-modal variant="primary" class="float-end">Add Notification</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchNotifications()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchNotifications()"/>
                           </label>
                        </div>                     
                         
                     </div>
                  </div>
                  <!----- Listing length and arch ends ----->

                 <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th>Title(English)</th>
                              <th>Title(Somali)</th>
                              <th>Notification (English)</th>
                              <th>Notification (Somali)</th>
                              <th>Type</th>
                              <th>User</th>
                              <th>Created On</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(notifications.length)">
                           <tr v-for="(notification) in notifications" :key="notification.id">
                              <td>{{notification.title_en}}</td>
                               <td>{{notification.title_so}}</td>

                              <td><p class="w-200px">{{notification.description_en}}</p></td>
                              <td><p class="w-200px">{{notification.description_so}}</p></td>

                              <td>
                                 <p v-if="notification.type==1">All Users</p>
                                 <p v-if="notification.type==4">Drivers</p>
                              </td>
                              <td>
                                 <span v-if="notification.user_id">
                                    <span v-if="notification.type==4 ">
                                       {{notification.name_en}}<br>
                                       {{notification.country_code}} {{notification.mobile}}
                                    </span>
                                    <br>
                                    
                                 </span>

                              </td>
                              <td>{{notification.created_at| formatDateTime}}</td>
                             </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No notifications found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
 
                 <!---- listing table ends -------->
 <!----pagination starts ---> 
                  <caption v-if="Boolean(notifications.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchNotifications(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&type=' + type )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="notification-modal" id="notification-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addNotification()">

                        <b-col md="12" class="form-group">
                           <label class="control-label">Title (English) <span class="text-danger">*</span></label>
                           <b-form-input v-model="notification.title_en" v-bind:class="{ 'is-invalid': Boolean(errors.title_en) }"></b-form-input>

                           <div v-for="(val, index) in errors.title_en" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>
                        <b-col md="12" class="form-group">
                           <label class="control-label">Title (Somali) <span class="text-danger">*</span></label>
                           <b-form-input v-model="notification.title_so" v-bind:class="{ 'is-invalid': Boolean(errors.title_so) }"></b-form-input>

                           <div v-for="(val, index) in errors.title_so" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>
                        

                       
                         <b-col md="12" class="form-group" >
                           <label class="control-label">Notification for <span class="text-danger">*</span></label>
                                                            
                           <b-form-radio-group v-model="driver_type" @change="driver_id=''">
                              <div class="form-check-inline">
                                 <b-form-radio name="driver_type"  :value="0">All drivers</b-form-radio>   
                              </div>
                              <div class="form-check-inline">
                                 <b-form-radio name="driver_type" :value="1">Specific driver</b-form-radio>
                              </div>
                           </b-form-radio-group>


                           <div class="search-select" v-if="driver_type">
                              <span class="search-close" v-if="driver_visible" @click="closedriverSearch"><i class="dripicons dripicons-cross"></i></span>
                                 
                              <b-form-input v-model="driver_keyword"  @keyup="fetchdrivers()"  v-bind:class="{ 'is-invalid': Boolean(errors.driver_id) }" autocomplete="off" placeholder="Search here..."></b-form-input>

                              <div v-for="(val, index) in errors.driver_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>   
                              <b-form-select class="form-control" v-if="driver_visible && Boolean(drivers.length)" v-model="driver_id" :select-size="drivers.length < 10 ? (drivers.length <= 1 ? 2 : drivers.length) : 10" @change="setdriver">
                                 <b-form-select-option v-for="driver in drivers" :key="driver.use_id" :value="driver.use_id">{{driver.country_code}} {{driver.mobile}} | {{ driver.name_en }}</b-form-select-option>
                              </b-form-select>

                              <b-form-select class="form-control" v-if="driver_visible && !Boolean(drivers.length)" v-model="driver_id" :select-size="2">                  
                                 <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                              </b-form-select>
                           </div>
                           
                           <div v-for="(val, index) in errors.user_id" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>

                       

                        

                        <b-col md="12" class="form-group">
                           <label class="control-label">Description (English) <span class="text-danger">*</span></label>
                           <textarea v-model="notification.description_en" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.description_en) }"></textarea>
                           
                           <div v-for="(val, index) in errors.description_en" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                          <b-col md="12" class="form-group">
                           <label class="control-label">Description (Somali) <span class="text-danger">*</span></label>
                           <textarea v-model="notification.description_so" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.description_so) }"></textarea>
                           
                           <div v-for="(val, index) in errors.description_so" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                           <b-button class="" variant="light" @click="hideModal('notification-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
